import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const photoUrl = (emp) =>
  emp?.photo_id ? `${API}/attachments/${emp.photo_id}/download` : null;

export const POSITIONS = ["Registered Nurse", "Home Health Aide", "Social Worker", "Chaplain", "Secretary", "Manager"];

export const SHIFT_LABELS = { working: "8a – 5p", on_call: "On Call", off: "Off" };
export const SHIFT_STYLES = {
  working: "bg-[#E6F0EB] text-[#1E3B30] border-[#BFE0CE]",
  on_call: "bg-[#F3E8FF] text-[#5B21B6] border-[#D8B4FE]",
  off: "bg-white/50 text-slate-400 border-slate-200",
};
export const OT_STYLE = "bg-[#FFECE5] text-[#9F1239] border-[#FECDD3]";

export const formatTime12 = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const ampm = h >= 12 ? "p" : "a";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return m === 0 ? `${hh}${ampm}` : `${hh}:${String(m).padStart(2, "0")}${ampm}`;
};

export const onCallLabel = (entry) =>
  entry?.on_call_start && entry?.on_call_end
    ? `On Call ${formatTime12(entry.on_call_start)}–${formatTime12(entry.on_call_end)}`
    : "On Call";

export const EVENT_TYPES = [
  { value: "pto", label: "PTO" },
  { value: "loa", label: "Leave of Absence" },
  { value: "late_entry", label: "Late Entry" },
  { value: "early_out", label: "Early Out" },
  { value: "call_off", label: "Call Off" },
];
export const EVENT_LABELS = {
  pto: "PTO",
  loa: "LOA",
  late_entry: "Late",
  early_out: "Early Out",
  call_off: "Call Off",
};
export const EVENT_BADGE_STYLES = {
  pto: "bg-rose-50 text-rose-700 border-rose-200",
  loa: "bg-rose-50 text-rose-700 border-rose-200",
  call_off: "bg-rose-50 text-rose-700 border-rose-200",
  late_entry: "bg-amber-50 text-amber-700 border-amber-200",
  early_out: "bg-amber-50 text-amber-700 border-amber-200",
};

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).map((p) => p[0]).slice(0, 2).join("").toUpperCase();
